import { render, staticRenderFns } from "./ApplyStatusDetail.vue?vue&type=template&id=09b66e67&scoped=true&"
import script from "./ApplyStatusDetail.vue?vue&type=script&lang=js&"
export * from "./ApplyStatusDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b66e67",
  null
  
)

export default component.exports